import { render, staticRenderFns } from "./MoneyInput2.vue?vue&type=template&id=b23683ae&lang=pug&"
import script from "./MoneyInput2.vue?vue&type=script&lang=js&"
export * from "./MoneyInput2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports